import React from 'react';

import cn from 'utils/cn';
import i18n from 'utils/i18n';

import './index.css';

const cnPageTitle = cn('page-title');

interface IPageTitleProps {
    section: string;
    mods: {
        [key: string]: string
    };
}

function PageTitle({ section, mods }: IPageTitleProps) {
    const title = i18n({
        keyset: 'sections',
        key: section
    }) || section;

    return <h1 className={cnPageTitle(mods)}>{ title }</h1>;
}

export default PageTitle;
